import { jsxs as c, jsx as m } from "react/jsx-runtime";
import { u as n } from "./index-6a632112.mjs";
import { M as x, a as u, b as M } from "./modalMixedStructure.modalWindow-3bb1e4ef.mjs";
import { r as s, B as d, Q as o, s as t } from "./themes-5f0b3c3d.mjs";
import "react";
import { useWindowDimensions as A } from "./useWindowDimensions.js";
import "react-dom";
import "./lineHeights-72d3110c.mjs";
import "./zIndices-d07533f3.mjs";
import "./closeButton.js";
import "./cancelClose-87fdf326.mjs";
import "./types-b577bf77.mjs";
import "./iconButton.js";
import "./button.js";
import "./textStyles-42cab346.mjs";
import "./fontWeights-a25f8f91.mjs";
import "./accessibility.js";
import "./index-c8707610.mjs";
import "./tslib.es6-59e1c9d8.mjs";
import "./superScript-393c70dc.mjs";
import "./disclosure.js";
import "./hTag-40b23797.mjs";
const l = "82px", W = "536px", f = n(x)`
  border-radius: ${s["4x"]};
  margin: auto;
  min-height: 200px;
  padding-top: 5px;
  height: unset;

  && > div {
    gap: 0;
  }

  ${(i) => i.$windowWidth < d.tabletMin ? `
      background: unset;
      padding: 0;
      height: 100%;
      margin-top: 10px;
      min-height: calc(100% - ${i.$mobileMargin} - ${i.$mobileMargin});
      min-width: 100%;
      top: 0;

      > div {
        margin-top: -4px;
      }
      ` : ""};

  @media ${o.laptopAndUp} {
    max-width: 900px;
    min-width: 100px;
  }
`, v = n.div`
  position: absolute;
  top: 0;
  left: 0;
  @media ${o.laptopAndUp} {
    max-width: 900px;
  }

  @media ${o.tabletAndUp} {
    position: relative;
  }

  div iframe {
    border-radius: ${s["2x"]};
  }
`, C = n(u)`
  ${(i) => i.$windowWidth < d.tabletMin ? `bottom: ${t["25x"]};
    position: absolute;
    right: ${t["12x"]};
    rotate: 180deg;
    .button[role="button"]{
      margin-top: unset;
    }

    > div{
      top: -82px;
      right: -${t["4x"]};
    }
    button > span{
      color: ${i.theme.components.modalVideo.closeIconColor} !important;
    }
    ` : ""};

  @media ${o.tabletAndUp} {
    padding: 10px 0;
  }
`, y = n(M)`
  padding: 0;

  ${(i) => i.$windowWidth < d.tabletMin ? `
    rotate: 90deg;
    overflow-y: unset;
    width: 100%;
    padding: 50%;
    margin-top: ${t["5x"]};
    ` : ""};
`;
function r({
  isOpen: i,
  handleCloseModal: e,
  children: g,
  mobileMargin: b = l,
  accessibilityOptions: h = {},
  idProps: $,
  modalVideoAccessibilityOptions: p = {
    modalAccessibilityOptions: h
  },
  ...w
}) {
  const { width: a } = A();
  return /* @__PURE__ */ c(
    f,
    {
      variant: "large",
      isOpen: i,
      onClose: e,
      bgOverlayColor: "rgba(0, 20, 46, 0.8)",
      $windowWidth: a,
      $mobileMargin: b,
      ...w,
      ...p.modalAccessibilityOptions,
      children: [
        /* @__PURE__ */ m(
          C,
          {
            idProps: $,
            onClose: e,
            $windowWidth: a,
            accessibilityOptions: p.modalHeaderAccessibilityOptions
          }
        ),
        /* @__PURE__ */ m(y, { $windowWidth: a, children: g })
      ]
    }
  );
}
r.Container = v;
r.mobileMargin = l;
r.tabletAndUpHeight = W;
export {
  r as ModalVideo
};
